export const StoreTypes = {
  WindowsAppStore: 'WindowsAppStore',
  AndroidPlayStore: 'AndroidPlayStore',
  IosAppStore: 'IosAppStore',
};

export const FLOWS = {
  ANDROID: 'ANDROID',
  IOS: 'IOS',
  WINDOWS: 'WINDOWS',
};

export const AppStoreTypes = {
  GoogleAppStore: 'GoogleAppStore',
  AppleAppStore: 'AppleAppStore',
  MicrosoftAppStore: 'MicrosoftAppStore',
};

export const APP_STORE_TO_STORE_TYPE = {
  [AppStoreTypes.GoogleAppStore]: StoreTypes.AndroidPlayStore,
  [AppStoreTypes.AppleAppStore]: StoreTypes.IosAppStore,
  [AppStoreTypes.MicrosoftAppStore]: StoreTypes.WindowsAppStore,
};

export const STORE_TYPE_TO_FLOW = {
  [StoreTypes.WindowsAppStore]: FLOWS.WINDOWS,
  [StoreTypes.AndroidPlayStore]: FLOWS.ANDROID,
  [StoreTypes.IosAppStore]: FLOWS.IOS,
};
